import axios from "axios";
import { cmsEnv, cmsHeaders } from "../exports/exports";
import { dynamicFailed } from "../hooks/useToast";

export const fetchAboutBanner = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_cmsUrl}/content-manager/${process.env.REACT_APP_cmsProjectId}/about-banner`,
      {
        headers: {
          ...cmsHeaders,
          ...cmsEnv,
        },
      },
    );
    return response.data.slice(-1);
  } catch (error: any) {
    dynamicFailed(`${error.message}`);
  }
};

export const fetchAboutDescriptionBanner = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_cmsUrl}/content-manager/${process.env.REACT_APP_cmsProjectId}/about-description`,
      {
        headers: {
          ...cmsHeaders,
          ...cmsEnv,
        },
      },
    );
    return response.data.slice(-1);
  } catch (error) {
    dynamicFailed("Server Error");
  }
};

export const fetchKeyObjectives = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_cmsUrl}/content-manager/${process.env.REACT_APP_cmsProjectId}/about-key-objective?sort=sort_order:asc`,
      {
        headers: {
          ...cmsHeaders,
          ...cmsEnv,
        },
      },
    );
    return response.data;
  } catch (error: any) {
    dynamicFailed(`${error.message}`);
  }
};

export const fetchObjectivesTrust = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_cmsUrl}/content-manager/${process.env.REACT_APP_cmsProjectId}/about-objectives-of-the-trust?sort=sort_order:asc`,
      {
        headers: {
          ...cmsHeaders,
          ...cmsEnv,
        },
      },
    );
    return response.data;
  } catch (error: any) {
    dynamicFailed(`${error.message}`);
  }
};
